import { Component } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { AuthStore } from '@store/auth.store';
import { environment } from '@envs/environment';
import { AdminPermission } from '@enums/admin-permission.enum';
import { AdminPermissionService } from '@services/admin-permission.service';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.css'
})
export class NavComponent {
  appVersion: string = environment.version;
  readonly P = AdminPermission;

  constructor(
    private router: Router,
    private AuthService: AuthService,
    private activatedRoute: ActivatedRoute,
    private authStore: AuthStore,
    private permissions: AdminPermissionService
  ) {
  }

  openParentMenu: Record<string, any> = {
    users: false,
    command_center: false,
    transactions: false,
    disc_rewards: false,
    cms: false,
    art_notifs: false
  }

  navArray: Record<string, any> = {
    home: false,
    users: false,
    partners: false,
    partner_earnings: false,
    transactions: false,
    admins: false,
    taxi_fleet_m: false,
    ads_m: false,
    news_and_events_m: false,
    notification_m: false,
    coupons_m: false,
    pricing_m: false,
    withdrawal_cms_m: false,
    rewards_cms_m: false,
    vehicle_cms_m: false,
    service_fee_cms_m: false,
    fleet_fee_distribution_cms_m: false,
    ride_config_cms_m: false,
    services_cms_m: false,
    payment_methods_cms_m: false,
    location_cms_m: false,
    m_top_ups: false,
    comcenter_overview: false,
    comcenter_express: false,
    comcenter_ride: false,
    comcenter_motaxi: false,
  };

  routeName: string = '';

  ngOnInit(): void {
    // Items stay hidden until permissions load; the API refuses what they hide
    // regardless, so this is about not offering dead ends.
    this.permissions.load().subscribe();

     // Access the route's data property
     this.activatedRoute.data.subscribe((data) => {
      this.routeName = data['name'];

      Object.keys(this.navArray).forEach((x) => {
        this.navArray[x] = false;
      });

      this.navArray[this.routeName] = true;
    });
  }

  can(permission: AdminPermission): boolean {
    return this.permissions.can(permission);
  }

  anyOf(permissions: AdminPermission[]): boolean {
    return permissions.some((permission) => this.permissions.can(permission));
  }

  navigateMenu(url: string, newTab: boolean = false) {
    if (newTab) {
        window.open(`/${url}`, '_blank');
    } else {
        this.router.navigate([`/${url}`]);
    }
  }

  openParentMenuFn(menu: string){
    Object.keys(this.openParentMenu).forEach((x) => {
      this.openParentMenu[x] = false;
    });

    this.openParentMenu[menu] = true;
  }
  accountLogout(){
    this.authStore.logout().subscribe(() => {
      this.router.navigate(['/admin/login']);
    });
  }
}
